var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Menu Icon"),React.createElement("path",{"d":"M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z","key":1})]);
}

MenuIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
